import Api from "./base/api-base";

export default class RankApi {
  list() {
    return Api.get({
      endpoint: Api.endpoint.rank
    });
  }

  store(params) {
    return Api.post({
      endpoint: Api.endpoint.rank,
      params: params
    });
  }

  info (id) {
    return Api.get({
      endpoint: Api.endpoint.rank,
      id: id
    });
  }
  
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.rank,
      id: id,
      params: params
    });
  }

  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.rank,
      id: id
    });
  }
}
